import React from 'react'
import { FormControl } from '@mui/material'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import TagPriority from './TagPriority'
import { useTranslation } from 'react-i18next'
import '../../i18n'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'

interface SelectPriorityProps {
  value: number
  onChange: (event: SelectChangeEvent<number>, child: React.ReactNode) => void
  disablePortalMenu?: boolean
  /** Hide floating label when a parent FormField already shows one. */
  hideLabel?: boolean
}

const SelectPriority: React.FC<SelectPriorityProps> = ({
  value,
  onChange,
  disablePortalMenu = false,
  hideLabel = true,
}) => {
  const { t } = useTranslation()
  const menu = useExclusiveMenu(!disablePortalMenu)

  const priorities = [1, 2, 3, 4]

  const options = priorities.map((p) => ({
    value: p,
    label: t(`priority.${p}`, { defaultValue: String(p) }),
  }))

  const selectedOption =
    options.find((opt) => opt.value === Number(value)) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: number; label: string }>
  ) => {
    onChange(
      {
        target: { name: 'priority', value: selected ? selected.value : 0 },
      } as unknown as SelectChangeEvent<number>,
      null
    )
  }

  const formatOptionLabel = (option: { value: number; label: string }) => (
    <TagPriority priority={option.value} />
  )

  return (
    <div style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('Priority')}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select<{ value: number; label: string }, false>
          value={selectedOption}
          onChange={handleSelectChange}
          options={options}
          placeholder={t('Priority')}
          formatOptionLabel={formatOptionLabel}
          styles={incyiaSelectStyles}
          isMulti={false}
          {...menu}
        />
      </FormControl>
    </div>
  )
}

export default SelectPriority
